import { Lightbulb } from "@mui/icons-material";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { FAKE_TEXT } from "helpers/constants";
import { FC } from "react";

export const Step5: FC = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Ask Student to Summarize. Provide Clarification as Needed
      </Typography>
      <Typography variant="body1" gutterBottom>
        {FAKE_TEXT.LONG2X}
      </Typography>

      <Box mt={2}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <Lightbulb />
            <Typography variant="body1">{FAKE_TEXT.MEDIUM}</Typography>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Lightbulb />
            <Typography variant="body1">{FAKE_TEXT.MEDIUM}</Typography>
          </Stack>
        </Stack>
      </Box>

      <Box>
        <Box mt={2}>
          <Typography variant="h5">Plan Next Steps Together</Typography>
        </Box>

        <Box mt={2}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
              <Lightbulb />
              <Typography variant="body1">{FAKE_TEXT.MEDIUM}</Typography>
            </Stack>
          </Stack>
        </Box>

        <Box>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              my: 2,
              background: "rgba(25,118,210,0.2)",
              border: "none",
              position: "relative",
            }}
          >
            {FAKE_TEXT.LONG}
          </Paper>
        </Box>
      </Box>
    </>
  );
};
